export const ADMIN_USAGE_PATH = "/admin/usage";

export function adminLicensePath(licenseId: string) {
  return `/admin/licenses/${encodeURIComponent(licenseId)}`;
}

export function adminCreateLicensePath() {
  return "/admin/licenses/new";
}

export function adminEditLicensePath(licenseId: string) {
  return `/admin/licenses/${encodeURIComponent(licenseId)}/edit`;
}

export function adminLicensesPath(scope: { product?: string; customer?: string } = {}) {
  const params = new URLSearchParams();
  if (scope.product) params.set("product", scope.product);
  if (scope.customer) params.set("customer", scope.customer);
  const search = params.toString();
  return search ? `/admin/licenses?${search}` : "/admin/licenses";
}

export function adminCustomerPath(customerId: string) {
  return `/admin/customers?customer=${encodeURIComponent(customerId)}`;
}
